import {IWidgetTabParams} from "~/chat/ts/data/ITab";
import {IPaymentParamsFromOperator} from "~/chat/vue/widget/tabs/payment/PaymentFormInterface";
import {PropType} from "vue";

export function useTabContentProps() {
    return {
        tab: {
            type: Object as PropType<IWidgetTabParams>,
            required: true
        },
        paramsFromOperator: {
            type: Object as PropType<IPaymentParamsFromOperator>
        }
    };
}